import { render, staticRenderFns } from "./plan-person.vue?vue&type=template&id=01fd648e"
import script from "./plan-person.js?vue&type=script&lang=js&external"
export * from "./plan-person.js?vue&type=script&lang=js&external"
import style0 from "./plan-person.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports